import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import './_input.scss'

const Input = forwardRef(({
  label,
  onChange,
  autoFocus,
  value,
  defaultValue,
  name,
  type = 'text',
  placeholder
}, ref) => {
  return (
    <label className="input">
      <span className="input__label">{label}</span>
      <input
        ref={ref}
        onChange={onChange}
        autoFocus={autoFocus}
        value={value}
        defaultValue={defaultValue}
        name={name}
        className="input__field"
        type={type}
        placeholder={placeholder}
        data-testid="input"
      />
    </label>
  )
})


Input.propTypes = {
  type: PropTypes.string,
  autoFocus: PropTypes.bool,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
}

export default Input
